import styled from 'styled-components';
import { doNotForwardTransientProp } from '../../util/doNotForwardTransientProp';
import { Text } from '../Text/Text';
export var StyledHeading = /*#__PURE__*/styled(Text).withConfig({
  shouldForwardProp: doNotForwardTransientProp(['fontFamily'])
}).withConfig({
  displayName: "StyledHeading",
  componentId: "c11n-8-111-1__sc-s7fcif-0"
})([""]);